import axios from '../../plugins/axios'
import fileDownload from 'js-file-download'

export const generateSettlements = (_, { data } = {}) => {
  return axios.post('/settlement/generate', data)
    .then(response => response)
    .catch(err => err.response)
}

export const listSettlements = ({ commit }, { params } = {}) => {
  return axios.get('/settlement', { params })
    .then((res) => {
      commit('SET_SETTLEMENTS', res.data.rows || res.data)
      return res.data.rows || res.data
    })
    .catch(err => {
      console.error(err)
      return err.response
    })
}

export const importDriverCountsExcel = (_, { data }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
  return axios.post('/settlement/import-driver-counts', data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const importShipmentsExcel = (_, { data }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
  return axios.post('/settlement/import-shipments', data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const downloadSheetBackupExcel = (_, { params } = {}) => {
  return axios.get('/settlement/sheet-backup-excel', { params, responseType: 'blob' })
    .then((response) => {
      const disposition = response.headers['content-disposition'] || ''
      const match = disposition.match(/filename=([^;]+)/)
      const filename = match
        ? match[1].replace(/"/g, '').trim()
        : 'Respaldo_GoogleSheet_Envios_Retiros.xlsx'
      fileDownload(response.data, filename)
      return response
    })
}
